var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReservation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13C10.5 12.7239 10.7239 12.5 11 12.5H14.5C14.7761 12.5 15 12.7239 15 13C15 13.2761 14.7761 13.5 14.5 13.5H11C10.7239 13.5 10.5 13.2761 10.5 13Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11C10.5 10.7239 10.7239 10.5 11 10.5H18.5C18.7761 10.5 19 10.7239 19 11C19 11.2761 18.7761 11.5 18.5 11.5H11C10.7239 11.5 10.5 11.2761 10.5 11Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16C10.5 15.7239 10.7239 15.5 11 15.5H17.5C17.7761 15.5 18 15.7239 18 16C18 16.2761 17.7761 16.5 17.5 16.5H11C10.7239 16.5 10.5 16.2761 10.5 16Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18C10.5 17.7239 10.7239 17.5 11 17.5H13.5C13.7761 17.5 14 17.7239 14 18C14 18.2761 13.7761 18.5 13.5 18.5H11C10.7239 18.5 10.5 18.2761 10.5 18Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50011 2.49967H4.50006C3.3955 2.49967 2.50008 3.39508 2.50006 4.49964L2.5 7.5M5.50011 2.49967V1.5M5.50011 2.49967H18.5001M5.50011 2.49967V4.5M18.5001 2.49967H19.5001C20.6047 2.49967 21.5001 3.39512 21.5001 4.49971L21.5 7.5M18.5001 2.49967V1.5M18.5001 2.49967V4.5M2.5 7.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V7.5M2.5 7.5H21.5M5.5 10.5V13.5H8.5V10.5H5.5ZM5.5 15.5V18.5001L8.5 18.5V15.5L5.5 15.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservation);
export default __webpack_public_path__ + "static/media/reservation.ddc8d06cff12d3ee96cc02cd30f0adb0.svg";
export { ForwardRef as ReactComponent };